module.exports = __webpack_public_path__ + "static/media/executive.f86c5285.jpg";